export const ZOOM_INITIAL_VALUE = 1;
export const ZOOM_STEP = 0.25;
